import {createSlice} from '@reduxjs/toolkit';
import {ITopupData, PartnerDetails} from '../interface';

export interface LoanLimitItem {
  ongoingLoanApplicationId: number | null;
  submittedLoanApplicationId: number;
  hasResumedApplication: boolean;
  bankAccountLinkInProgress: boolean;
  processingApplication: boolean;
  hasAvailableLimit: boolean;
  limitBlocked: boolean;
  availableLimit: number;
  finalAvailableLimit: number;
  partnerDetails: PartnerDetails;
  currency: string;
  currencySymbol: string;
  toHideLimit: boolean;
  productType: string;
  isExtraCard?: true;
  mpId: string | number;
  id?: string;
  linkBankAccountDisplay: string;
  topUpLimitTiles: ITopupData[];
  pocketType: string;
  smeMaskedId: string;
  lastLimitEvaluationDate: string;
  isExpired: boolean;
  isRefreshLimit: boolean;
  isPocketUpdating: boolean;
  advanceId: string | number;
  ongoingApplicationProductType: string;
}

interface LoanLimitResponse {
  data: LoanLimitItem[];
  isPayroll: boolean;
  newPocketIntent: boolean;
  pocketSubmitted: boolean;
  isPAYE: boolean;
  languagePreference: string | null;
  isIndrive: boolean;
  isJaidee: boolean;
}

const initialState: LoanLimitResponse = {
  data: [],
  isPayroll: false,
  newPocketIntent: false,
  pocketSubmitted: false,
  isPAYE: false,
  languagePreference: null,
  isIndrive: false,
  isJaidee: false,
};

const dashboard = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setLoanLimitData(state, action) {
      state.data = action.payload;
    },
    setPayroll(state, action) {
      state.isPayroll = action.payload;
    },
    setNewPocketIntent(state, action) {
      state.newPocketIntent = action.payload;
    },
    setPocketSubmitted(state, action) {
      state.pocketSubmitted = action.payload;
    },
    setPAYE(state, action) {
      state.isPAYE = action.payload;
    },
    setLanguagePreference(state, action) {
      state.languagePreference = action.payload;
    },
    setIndrive(state, action) {
      state.isIndrive = action.payload;
    },
    setJaidee(state, action) {
      state.isJaidee = action.payload;
    },
  },
});

const dashboardReducer = dashboard.reducer;

export const dashboardActions = dashboard.actions;

export default dashboardReducer;
